var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMNavLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9158 9.7301C18.9158 14.8874 15.1599 18.4602 9.93304 18.4602C4.67466 18.4602 0.94873 14.8874 0.94873 9.7301C0.94873 4.60389 4.67466 1 9.93304 1C15.1614 1.00155 18.9158 4.60389 18.9158 9.7301Z",
    fill: "black",
    stroke: "url(#paint0_linear_671_82864)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4475 15.2897C13.9105 15.2897 16.3141 14.5072 18.3329 13.0482C17.0859 16.3569 13.9429 18.4618 9.93304 18.4618C7.99045 18.4618 6.25669 17.9725 4.84294 17.0979C5.26667 16.5355 5.80878 16.0804 6.4281 15.7671C7.04742 15.4538 7.72765 15.2905 8.41713 15.2897H11.4475ZM11.4475 12.1565H8.41713C7.301 12.1566 6.19879 12.4127 5.18998 12.9064C4.18117 13.4001 3.29089 14.1192 2.58334 15.0117C2.89235 15.4332 3.24056 15.8224 3.62299 16.1736C4.18727 15.413 4.91305 14.7967 5.7443 14.3722C6.57555 13.9477 7.49002 13.7265 8.41713 13.7255H11.4475C14.2315 13.7258 16.9031 12.5897 18.8813 10.5643C18.9038 10.2909 18.9158 10.0144 18.9158 9.73324C18.9161 9.24074 18.88 8.74895 18.8077 8.26216C17.967 9.46782 16.8613 10.4497 15.5816 11.1268C14.3019 11.8038 12.885 12.1568 11.4475 12.1565ZM11.4475 4.3243C11.849 4.32389 12.2339 4.15879 12.5179 3.86523C12.8018 3.57167 12.9615 3.17363 12.9619 2.75848V1.44586C11.978 1.14632 10.9572 0.99665 9.93154 1.00158C6.08992 1.00158 3.06861 2.92624 1.71796 5.96003C3.79817 4.88685 6.09085 4.32746 8.41562 4.32585L11.4475 4.3243ZM11.4475 7.4575C12.5984 7.45563 13.7059 7.00276 14.5467 6.19016C15.3875 5.37757 15.8992 4.26565 15.9787 3.07848C15.514 2.68811 15.0103 2.35014 14.4763 2.07032V2.75848C14.4751 3.58907 14.1554 4.3853 13.5874 4.97263C13.0194 5.55995 12.2493 5.89044 11.446 5.89168H8.41713C5.81427 5.89053 3.26642 6.66617 1.07944 8.12546C0.991832 8.65606 0.948105 9.19341 0.948737 9.73168C0.948737 9.86683 0.948737 9.99887 0.957751 10.1325C3.08272 8.3994 5.71066 7.45756 8.41713 7.45906L11.4475 7.4575ZM8.41713 10.5907H11.4475C12.8647 10.5896 14.2531 10.1771 15.4547 9.40015C16.6564 8.62323 17.6229 7.51311 18.2443 6.19615C17.9908 5.57819 17.6637 4.99531 17.2707 4.461C16.9115 5.7725 16.1488 6.92728 15.0981 7.7505C14.0473 8.57372 12.7658 9.02055 11.4475 9.02333H8.41713C5.7381 9.02502 3.15998 10.0802 1.20564 11.9748C1.33539 12.5393 1.52117 13.0885 1.76002 13.6136C2.60739 12.6615 3.63644 11.9013 4.78224 11.381C5.92804 10.8607 7.1657 10.5916 8.41713 10.5907Z",
    fill: "url(#paint1_radial_671_82864)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9158 9.7301C18.9158 14.8874 15.1599 18.4602 9.93304 18.4602C4.67466 18.4602 0.94873 14.8874 0.94873 9.7301C0.94873 4.60389 4.67466 1 9.93304 1C15.1614 1.00155 18.9158 4.60389 18.9158 9.7301Z",
    stroke: "url(#paint2_linear_671_82864)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_671_82864",
    x1: 0.573132,
    y1: 9.73165,
    x2: 19.2914,
    y2: 9.73165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_671_82864",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.93304 9.73168) scale(8.71838 9.01437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_671_82864",
    x1: 0.573132,
    y1: 9.73165,
    x2: 19.2914,
    y2: 9.73165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMNavLogo);
export default __webpack_public_path__ + "static/media/m-nav-logo.81fd800bc4f6beb596890045a73456b7.svg";
export { ForwardRef as ReactComponent };